import { TransportOnAPW } from './transport.class';

export const transport = new TransportOnAPW();
